/* eslint-disable @typescript-eslint/no-explicit-any */
import { DateTime } from 'luxon';
import { TypeFile } from 'practice/components/detail/form/accordion-attachments/form';
import { QuestionarioList } from 'shell/models/act-wizard';
import {
  AccordionGeneralityForm,
  ForeignForm,
} from 'civil-status/view-models/accordion-generality-form';
import { AttachmentsData } from 'shell/models/act-wizard';
import { DatePickerView } from '@mui/lab/DatePicker/shared';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { ItalianForm } from 'shell/view-models/italian-form';
import { ItemVM } from 'shell/view-models/item';
import { ItemValoreDominioAttoVM } from 'civil-status/components/step/form/last-step/accordions/section/list/list-authority';
import { ItemTemplateVM } from 'civil-status/components/step/form/last-step/accordions/section/list/list-template-transcription';
import { ResponsePublication } from 'civil-status/model/publication';
import { ActOperator } from 'shell/models/act-list';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export enum IdType {
  Radio = 'RB',
  Checkbox = '', // per ora non c'è
  Select = 'LST',
}

export interface OptionsVM {
  id: string | number;
  value: string;
  parte?: string; // utile per titolo dell'ultimo step
  serie1?: string; // utile per titolo dell'ultimo step
  serie2?: string; // utile per titolo dell'ultimo step
  responseData?: QuestionarioList; // utile per il salvataggio, abbiamo tutto i dati ed in base a quelli che servono li formattiamo
  codResponse?: number; // utile per mantenere l'id della risposta
}

export interface RequestVM {
  name: string; // identificativo del campo
  type: string; // RB = Radio, '' = Checkbox, LST = Select
  request: string; // domanda
  options?: Array<OptionsVM>; // opzioni di risposta da formattare in base al type
}

export interface RequestsType {
  step?: number;
  requests: Array<RequestVM>;
  idValore?: string | number;
  descrizioneValore?: string;
  dateFormationAct?: string;
}

export interface RecapVM {
  step?: string; // step della domanda
  codResponse?: number; // codice della risposta data
  request?: string; // domanda come testo
  response?: string; // risposta come testo
  tipoAtto?: string; // utile per mantenere il campo
  flagAusilioInterprete?: string; // utile per mantenere il campo se non salvo il dichiarante
  nascitaIstat?: string; // utile per mantenere il campo se non salvo il nascituro
  luogoEvento?: string; // utile per mantenere il campo se non salvo il nascituro
  tipoResidenzaNascituro?: string; // utile per mantenere il campo se non salvo il nascituro
  tipoContenuto?: string; // utile per mantenere il campo
  parte?: string; // utile per titolo dell'ultimo step
  serie1?: string; // utile per titolo dell'ultimo step
  serie2?: string; // utile per titolo dell'ultimo step
  role?: string; // utile per titolo dell'ultimo step
  codiceStatoEvento?: string; // utile per salvataggio post "valida evento"
  idAnsc?: string; // utile per salvataggio post "valida evento"
  numeroAtto?: number; // utile per salvataggio post "valida evento"
  codStepSuccessivo?: string; // step successivo
  responseData?: QuestionarioList; // utile per il salvataggio, abbiamo tutto i dati ed in base a quelli che servono li formattiamo
  disabled?: boolean;
}

export interface SearchPersonVM {
  fiscalCode?: string;
  surname?: string;
  withoutSurname?: boolean;
  name?: string;
  withoutName?: boolean;
  gender?: string;
  birthdayDate?: DateTime | null;
  birthdayDateChoice?: Array<DatePickerView>;
  idAnpr?: string;
}

export interface ParentVM {
  eventType?: string;
  searchPerson?: SearchPersonVM;
  generality?: AccordionGeneralityForm;
  isFromSearchPerson?: boolean; // generalità è risultato della ricerca
  configuration?: string;
  codeSubject?: string;
  nameSubject?: string;
  flagDichiarante?: string;
  tipoSoggetto?: string;
  flagComparente?: string;
  flagFirmatario?: string;
  presenza?: string;
  idDatiEventoRiconoscimento?: number;
  isSaved?: boolean; // se la sezione è stata salvata
}

export interface RiconoscimentoList {
  codiceSezione?: string;
  key: {
    idRiconoscimento?: number;
  };
}

export interface ActFormVM {
  idAnsc?: string; // solo digitale
  idEventoCollegato?: string;
  italian?: ItalianForm;
  typeEvent?: string;
  dateAct?: DateTime | null;
  register?: string;
  disabledRegister?: boolean;
  year?: string;
  portion?: string; // solo cartaceo
  serie?: string; // solo cartaceo
  volume?: string; // solo cartaceo
  municipalNumber?: string;
  presentationDocument?: string;
  nameSurnameGroom?: string; // solo ricerca atto separazioni
  nameSurnameWife?: string; // solo ricerca atto separazioni
  useCase?: string; // solo ricerca atto separazioni
  descUseCase?: string; // solo ricerca atto separazioni
  actSearched?: ModelEventoDTO;
}

export interface Annotations {
  disabled?: boolean;
  idAnnotazione?: number;
  typeContextualAnnotation?: string;
  isNotCertifiable?: boolean;
  textContextualAnnotation?: string;
  dateInsertion?: string;
}

export interface PublicationVM {
  year?: string;
  number?: string;
  part?: string;
  serie?: string;
  register?: string;
  yearSurname?: string;
  nameSurnameGroom?: string; // only visualization
  nameSurnameWife?: string; // only visualization
  surnameGroom?: string; // only filter
  surnameWife?: string; // only filter
  state?: string;
  date?: DateTime | null;
  time?: DateTime | null;
  residence?: string;
  reducedDay?: number;
  response?: ResponsePublication;
}

export interface SectionVM {
  eventType?: string;
  configuration?: string;
  codeSection?: string;
  typeSection?: string;
  typePersistence?: string;
  typePresence?: string;
  isSaved?: boolean;
  isDatePresumed?: boolean;
  // per data presunta
  datePresumedStart?: DateTime | null;
  datePresumedEnd?: DateTime | null;
  notePresumed?: string;
  // per data certa
  dateDeath?: DateTime | null;
  timeDeath?: DateTime | null;
  isForeign?: boolean;
  isForeignDelegating?: boolean;
  // italian form
  italian?: ItalianForm;
  disabledRegister?: boolean;
  // foreign form
  foreign?: ForeignForm;
  placeDeath?: string;
  otherPlaceDeath?: string;
  address?: string;
  conditionsItem?: ItemVM;
  reasonImpediment?: string; // abilitato se conditionsItem è tre
  isWithInterprete?: boolean;
  isLawyerHusbandWife?: boolean;
  numberAppearing?: string;
  numberHolders?: string;
  numberChildren?: string;
  authority?: ItemValoreDominioAttoVM;
  otherAuthority?: string;
  dateCommunication?: DateTime | null;
  typeCommunication?: ItemVM;
  numeroNullaOsta?: string;
  dateConferralDecree?: DateTime | null;
  dateNotificationDecree?: DateTime | null;
  extremesDecree?: string;
  typeExtremesDecree?: string;
  extremesPec?: string;
  dateRegistrationCourt?: DateTime | null;
  isInterestedPresent?: boolean;
  authorityPostAddress?: string;
  summaryStatement?: string;
  presentationDocument?: string;
  certificateReleaseFrom?: string;
  certificateDate?: DateTime | null;
  conceivedMonth?: string;
  isIncestuousSonSentence?: boolean;
  judgmentPublicationDate?: DateTime | null;
  effectiveDateSentence?: DateTime | null;
  documentDateFormation?: DateTime | null;
  timeDocumentFormation?: DateTime | null;
  dateStipulation?: DateTime | null;
  documentRequestDate?: DateTime | null;
  documentExtremes?: string;
  documentDescription?: string;
  nameInstitution?: string;
  dateTranscription?: DateTime | null;
  templateTranscription?: string;
  contextualAnnotationTemplate?: ItemTemplateVM;
  templateTranscription2?: string;
  templateTranscriptionText?: string;
  idTemplateIcaro?: string;
  disableTemplate?: boolean;
  hiringTiming?: string;
  reasonLossCitizenship?: string;
  applicant?: ItemVM;
  typeApplicant?: string;
  typeRequest?: string;
  typeBirthPlace?: string;
  descriptionBirthPlace?: string;
  typeResidence?: string;
  typeService?: string;
  nationEmployment?: ForeignStateVM;
  typeAct?: string;
  actForm?: ActFormVM;
  actComposition?: string;
  effectiveDate?: DateTime | null;
  effectiveTime?: DateTime | null;
  reasonRecovery?: string;
  descriptionsReasonRecovery?: string;
  typologyConsent?: string;
  typeDeclaration?: string;
  isRequiredFromOtherAccordion?: boolean; // => true se la sezione è obbligatorio in base ai dati di un'altra sezione
  sentenceRecognition?: string;
  changeSurname?: string;
  dateMarriage?: DateTime | null;
  reasonLackConsent?: string;
  parentCitizenship?: string;
  parentTransmittedCitizenship?: string;
  dateOutcomeVerification?: DateTime | null;
  assessmentResult?: string;
  parentRecognition?: string;
  dateMeasureMayor?: DateTime | null;
  dateOath?: DateTime | null;
  extremesOath?: string;
  dateEffectiveMeasure?: DateTime | null;
  protocolNumber?: string;
  oldSurnameRegistered?: string | null;
  newSurnameRegistered?: string | null;
  oldNameRegistered?: string | null;
  newNameRegistered?: string | null;
  newName?: string;
  newSurname?: string;
  oldSurname?: string;
  nameAdded?: string;
  surnameAdded?: string;
  typeDisappearance?: string;
  rolo?: string;
  dateLastSighting?: DateTime | null;
  isPaternitySentence?: boolean;
  nameInstituteAbandonedMinor?: string;
  dateChangeSurname?: DateTime | null;
  typeMutation?: string;
  parentChangedSurname?: string;
  measureExchangeSurname?: string;
  annotations?: Array<Annotations>;
  annotationsPropertyRegime?: Annotations;
  dateEvent?: DateTime | null;
  timeEvent?: DateTime | null;
  numberWitnesses?: string;
  opposition?: string;
  genericImpediment?: string;
  dateIncorporationCertificate?: DateTime | null;
  reason?: string;
  propertyRegime?: string;
  lawPropertyRegime?: string;
  isWithNotarialDeed?: boolean;
  nameNotary?: string;
  surnameNotary?: string;
  notarialDistrict?: string;
  datePropertyRegime?: DateTime | null;
  repertoireNumber?: string;
  collectionNumber?: string;
  dataDelegate?: DateTime | null;
  textDelegate?: string;
  publication?: string;
  ageDefect?: string;
  relationship?: string;
  isTemporaryBanRemarriage?: boolean;
  minorGroomAssistance?: string;
  minorWifeAssistance?: string;
  place?: string;
  houseNumber?: string;
  italianDelegating?: ItalianForm;
  foreignDelegating?: ForeignForm;
  dataSend?: DateTime | null;
  otherTypeCommunicationDescription?: string;
  dataReception?: DateTime | null;
  impedimentUnitedCivilly?: string;
  dataCivilUnion?: DateTime | null;
  typeActToTranscribed?: string;
  isReductionTerms?: boolean;
  dataStart?: DateTime | null;
  dataEnd?: DateTime | null;
  isSonUnderFourteen?: boolean;
  presentationDocumentRecognition?: string;
  declarant?: string;
  ritualReligious?: ItemVM;
  otherRitualReligious?: string;
  isRecognizedRite?: boolean;
  isMaintenanceAllowance?: boolean;
  maintenanceAllowance?: string;
  isPendingJudgment?: boolean;
  judicialAuthority?: string;
  isHusband?: boolean;
  isWife?: boolean;
  isLawyerHusband?: boolean;
  isLawyerWife?: boolean;
  dateAgreementConfirmation?: DateTime | null;
  celebratedBy?: string;
  typeAgreement?: string;
  typeSeparation?: string;
  typeMeasure?: string;
  receiptDocument?: string;
  depositDate?: DateTime | null;
  surnameEditor?: string;
  nameEditor?: string;
  gender?: string;
  isReceivedPrivateCitizen?: boolean;
  dateReconciliation?: DateTime | null;
  typeModificationMarriage?: string;
  typeEvent?: string;
  consentReturnedBefore?: string;
  publicationData?: PublicationVM;
  filterPublication?: PublicationVM;
  isNotCertifiable?: boolean;
  isSonUnknownParents?: boolean;
  ufcDelegate?: string;
  isSimpleCertificate?: boolean;
  isAbstractForSummary?: boolean;
  isNotary?: boolean;
  isReceivedByPost?: boolean;
  dateReport?: DateTime | null;
  requestProtocol?: string;
  numberLawCitizenship?: string;
  emergencyRegister?: ItemVM;
  margin?: string;
  number?: string;
  identifier?: string;
  isResidencePresentationDocuments?: boolean;
  // id identificativi
  idCertSanitario?: number;
  idDatiEventoRiconoscimento?: number;
  idEnteDichiarante?: number;
  idAttoCollegato?: number;
  idConsenso?: number;
  idLuogo?: number;
  idCertificatoUnioneCivile?: string;
  idImpedimento?: number | null;
  idCertificato?: number;
  idRegimePatrimoniale?: number | null;
  idPubblicazione?: number;
  riconoscimentoList?: Array<RiconoscimentoList>; // utile al BE per i salvataggi
}

export interface TextActVM {
  text?: string;
  isEditText?: boolean;
}

export interface DocumentVM {
  file?: TypeFile;
  files?: Array<TypeFile>;
  obligatoryFiles?: Array<string>; // i files obbligatori, è un array di tipoAllegato
  obligatoryFilesCurrent?: Array<string>; // i files ancora da inserire
  descriptions?: Record<string, string>;
  currentDescription?: string;
  typeDocument?: string;
  isSaved?: boolean; // se la sezione è stata salvata
}

export interface SignatoriesVM {
  name?: string;
  surname?: string;
  dateBorn?: DateTime | null;
  fiscalCode?: string;
  gender?: string;
  isAutografa?: boolean;
  email?: string;
  isSend?: boolean; // firma con email inviata
  isVerify?: boolean; // firma con email verificata
  idPresaVisione?: string;
  idSubject?: number; // valore identificativo del soggetto
}

export interface SignatureActVM {
  idState?: number;
  idAnsc?: string;
  signatories?: Array<SignatoriesVM>;
  document?: TypeFile;
  operatorName?: string;
  operatorSurname?: string;
  idEventoCorrelato?: string;
  allegatoList?: Array<AttachmentsData>;
}

export interface SignatureActUscVM {
  idState?: string;
  idAnsc?: string;
  isAnagrafica?: boolean;
  dateValidity?: DateTime | null;
  user?: string;
  pin?: string;
  otp?: string;
  operatorName?: string;
  operatorSurname?: string;
  document?: TypeFile;
  documentsSelected?: Array<number>; // idAllegato selezionati
  allegatoList?: Array<AttachmentsData>;
  idEventoCorrelato?: string;
}

export interface ResponseSaveAll {
  idSubject?: number;
  codeSubject?: string;
}

export interface ErrorsWarnings {
  code?: string;
  text?: string;
}

interface ErrorsWarningsANSC {
  errors?: Array<ErrorsWarnings>;
  warnings?: Array<ErrorsWarnings>;
}

export interface ResponseValidateEvent extends ErrorsWarningsANSC {
  codiceStatoEvento?: string;
  idAnsc?: string;
  numeroAtto?: number;
  forcingCode?: string;
}

export interface ResponsePreview extends ErrorsWarningsANSC {
  eventoOutput?: {
    contenuto?: string;
  };
}

export interface Head {
  idAnsc?: string;
  municipality?: string;
  dateFormation?: string;
  effectiveDate?: string;
  register?: string;
  idTipoEvento?: string;
  state?: string;
  usecase?: string;
  typeContent?: string;
  idUC?: string;
  descriptionsUC?: string;
}

export interface Holders {
  title?: string;
  name?: string;
  surname?: string;
  dateBorn?: DateTime | null;
  fiscalCode?: string;
  municipality?: MunicipalityAnprVM | null;
  municipalityAire?: MunicipalityAnprVM | null;
  state?: ForeignStateVM | null;
  idAnpr?: string;
  idNationalIdentifier?: string;
  idAnsc?: string;
  idComuneResidenza?: string;
}

export interface Annotation {
  type?: string;
  text?: string;
}

export interface CommunicationVM {
  elementSelected?: string;
}

export interface ViewStepVM {
  idAnsc?: string;
  idEvento?: number;
  idEventoCorrelato?: number;
  head?: Head;
  holders?: Array<Holders>;
  document?: DocumentVM;
  annotations?: Array<Annotation>;
  comunication?: CommunicationVM;
  textAct?: string;
}

export type LastStepVM = Record<string, ParentVM | DocumentVM | SectionVM | TextActVM> | any;

export type StepVM = Record<string, string | boolean> & LastStepVM;

export interface QuestionarioEvento {
  key: {
    idEvento?: number;
    numProgressivoStep?: number;
  };
  codStep?: string;
  idRisposta?: number;
  cdStepSuccessivo?: string;
  descBreveDomanda?: string;
  testoDomanda?: string;
  descBreveRisposta?: string;
  testoRisposta?: string;
  codiceOperatoreInserimento?: string;
}

export interface AllegatoAtti {
  key?: { idAllegato?: number };
  codStato?: string;
  nomeFile?: string;
  descrizioneTipoAllegato?: string;
  tipoAllegato?: string;
  oggettoAllegato?: string;
  idAnscAllegato?: string;
}

export interface StatoCivile {
  key?: {
    idEvento?: number;
  };
  tipoEvento?: string;
  tipoContenuto?: string;
  tipoUseCase?: string;
  codiceStatoEvento?: string;
  idAnsc?: string;
  idIcaro?: number;
  numeroAtto?: number;
  dataFormazioneAtto?: DateTime | string;
  tipoAtto?: string;
  parteAtto?: string;
  serie1Atto?: string;
  serie2Atto?: string;
  nascitaIstat?: string;
  luogoEvento?: string;
  tipoResidenzaNascituro?: string;
  flagTestoEditabile?: string;
  autorita?: string;
  codiceRito?: string;
  idMotivoVariazioneCittadinanza?: string;
  idEventoCollegato?: string;
  idEventoCorrelato?: number;
  idRdE?: string;
  descRdE?: string;
  codMargineRdE?: string;
  numeroAttoRdE?: string;
  timestampDecorrenza?: DateTime | string;
  flagResidenzaDaAltraDoc?: string;
  codiceTempisticaGiuramento?: string;
  numeroPecRiammissione?: string;
}

export interface Evento {
  key?: {
    idEvento?: number;
  };
  tipoEvento?: string;
  tipoContenuto?: string;
  flagAusilioInterprete?: string;
  dataFormazioneAtto?: DateTime | string;
  tipoUseCase?: string;
  descrizioneUseCase?: string;
  codiceStatoEvento?: string;
  idAnsc?: string;
  numeroAtto?: number;
  ruoloOperatore?: string;
  operatoreNome?: string;
  operatoreCognome?: string;
  composizioneCompleta?: string;
  composizioneCompletaAnnotazione?: string;
  flagAnnotazNonCertificabile?: string;
  noteRitardo?: string;
  flagSentenzaFiglioInc?: string;
  tipoDatiProdotti?: string;
  motivoRecupero?: string;
  descrizioneMotivoRecupero?: string;
  timestampDecorrenza?: DateTime | string;
  riconoscimentoSentenza?: string;
  tipoConsenso?: string;
  tipoDichiarante?: string;
  flagCertificatoSemplice?: string;
  flagEstrattoPerRiassunto?: string;
  idAttoCartaceo?: string;
  codiceSezione?: string;
  flagRedattoNellaCC?: string;
}

export interface SoggettoList {
  key: {
    idSoggetto?: number;
  };
  idSoggettoAnpr?: string;
  idSoggettoAnsc?: string;
  idAnpr?: string;
  codiceSoggetto?: string;
  codiceFiscale?: string;
  cognome?: string;
  nome?: string;
  sesso?: string;
  dataNascita?: string;
  idComuneNascita?: number;
  comuneNascita?: string;
  idProvNascita?: number;
  siglaProvNascita?: string;
  idStatoNascita?: number;
  statoNascita?: string;
  nomeLocalitaEsteraNascita?: string;
  idComuneResidenza?: number;
  nomeComuneResidenza?: string;
  flagIrreperibile?: string;
  idComuneAire?: number;
  nomeComuneAire?: string;
  idProvinciaAire?: number;
  siglaProvinciaAire?: string;
  idProvResidenza?: number;
  siglaProvResidenza?: string;
  idStatoResidenza?: number;
  nomeStatoResidenza?: string;
  indirizzoResidenza?: string;
  tipoStatoCivile?: string;
  descrizioneStatoCivile?: string;
  impedimento?: string;
  genere?: string;
  codiceNazionalita?: number;
  descrizioneNazionalita?: string;
  note?: string;
  idFormatoData?: string;
  descrizioneFormatoData?: string;
  numeroAnni?: number;
  flagDichiarante?: string;
  flagComparente?: string;
  flagFirmatario?: string;
  tipoDocRiconoscimento?: string;
  email?: string;
  pec?: string;
  ruolo?: string;
  descrizioneDocRiconoscimento?: string;
  numeroDocRiconoscimento?: string;
  dataScadenzaDocRicon?: string;
  docRiconRilasciatoDa?: string;
  dataRilascioDocRicon?: string;
}

export interface FiglioList {
  key: {
    idSoggetto?: number;
  };
  nuovoCognome?: string;
  idAnsc?: string;
  idAttoCartaceo?: string;
  idComuneRegistrazione?: number;
  nomeComuneRegistrazione?: string;
  idProvinciaRegistrazione?: number;
  siglaProvinciaRegistrazione?: string;
  codiceSoggetto?: string;
}

export interface DatiNascita {
  key?: {
    idEvento?: number;
  };
  luogoFiliazione?: string;
  indirizzoEvento?: string;
  sceltaCognome?: string;
  oraNascita?: string;
  minutoNascita?: string;
  precisazioneCognome?: string;
  flagNatoMorto?: string;
  flagNatoVivoMaDeceduto?: string;
  flagPartoGemellare?: string;
  dataAccertamentoNecroscopo?: string;
  numeroGemelli?: number;
  progressivoGemello?: number;
  idEventoGemelloPrec?: number;
  idEventoGemelloSucc?: number;
  accertamento?: string;
  nascitaSoggetto?: string;
}

export interface DatiDichiarante {
  key?: {
    idEvento?: number;
  };
  ruolo?: string;
  procura?: string;
  datiEssenzialiProcura?: string;
  titoloDichiarante?: string;
  dichiarazioneCongiunta?: number;
  comprensione?: string;
  motivoImpedimento?: string;
}

export interface FirmatariList {
  key?: {
    idSoggetto?: number;
  };
  codiceOperatoreInserimento?: string;
  timestampInserimento?: string;
  codiceOperatoreUltimoAggiornamento?: string;
  timestampUltimoAggiornamento?: string;
  note: null;
  idEvento?: number;
  tipoFirma?: string;
  codStatoFirma?: string;
  emailNotificaFirma?: string;
  idPresaVisione?: number;
}

export interface EnteDichiaranteList {
  key?: {
    idEnteDichiarante?: number;
  };
  nomeEnteDichiarante?: string;
  ruolo?: string;
  idComune?: number;
  nomeComune?: string;
  idProvincia?: number;
  siglaProvincia?: string;
  indirizzo?: string;
  civico?: number;
  lettera?: string;
  idNazione?: number;
  nomeNazione?: string;
  nomeComuneEstero?: string;
  dataTrascrizione?: string;
  trascrizione?: string;
  estremiDocumento?: string;
  anagraficaConsolato?: string;
  nomeAnagraficaConsolato?: string;
  sezione?: string;
  tipoPersistenza?: string;
  configurazione?: string;
  codiceSezione?: string;
  tipoSezione?: string;
}

export interface DatiMorte {
  key?: {
    idEvento?: number;
  };
  nrNullaOsta?: string;
  luogoMorte?: string;
  luogoRitrovamento?: string;
  idComuneMorte?: number;
  nomeComuneMorte?: string;
  nomeComuneEsteroMorte?: string;
  idProvinciaMorte?: number;
  siglaProvincia?: string;
  idStatoMorte?: number;
  nomeStatoMorte?: string;
  indirizzoMorte?: string;
  dataMorte?: string;
  dataMortePresuntaDa?: string;
  dataMortePresuntaA?: string;
  oraMortePresuntaDa?: number;
  oraMortePresuntaA?: number;
  noteDataPresuntaMorte?: string;
  annoMorte?: number;
  meseMorte?: number;
  giornoMorte?: number;
  oraMorte?: number;
  minutoMorte?: number;
  codiceSezione?: string;
}

export interface DatiEventoMorte {
  key?: {
    idEvento?: number;
  };
  numComparenti?: number;
  idComparente1?: number;
  idComparente2?: number;
  tipoTrasmissione?: string;
  descTrasmissione?: string;
  dataTrasmissione?: string;
}

export interface DatiEventoCittadinanza {
  key?: {
    idEvento?: number;
  };
  estremiDecretoConf?: string;
  dataDecretoConferimento?: string;
  dataNotificaDecreto?: string;
  codiceSezione?: string;
  indirizzoAutorita?: string;
  riassuntoDichiarazione?: string;
  flagIntestatarioApolide?: string;
  infoResidenzaBiennale?: string;
  dataInizioResidenza?: string;
  tempoAssunzione?: string;
  ulterioreCittadinanza?: number;
  nomeUlterioreCittadinanza?: string;
  motivoPerditaCittadinanza?: number;
  testoMotivoPerditaCittadinanza?: string;
  tipoPerditaPerMatrimonio?: number;
  residenza?: string;
  provinciaResidenza?: number;
  siglaProvResidenza?: string;
  comuneResidenza?: number;
  nomeComuneResidenza?: string;
  impiego?: string;
  nazioneImpiego?: number;
  nomeNazioneImpiego?: string;
  dataRegistrazioneDecreto?: string;
  eventoCittadinanza?: string;
  protocollo?: string;
  dataVerbale?: string;
  estremiGiuramento?: string;
  dataGiuramento?: string;
  tipoOfficiante?: string;
}

export interface CertificatoSanitario {
  key?: {
    idCertSanitario?: number;
  };
  autorita?: string;
  dataRilascio?: string;
}

export interface DatiEventoRiconoscimento {
  key?: {
    idDatiEventoRiconoscimento?: number;
  };
  mesiDalConcepimento?: number;
  datiProdotti?: string;
  assenzaFiglio?: string;
  descrizioneAssensoReso?: string;
  sceltaCognome?: string;
  nuovoCognome?: string;
  dataComunicazione?: string;
  flagRiconosciutoDalPadre?: string;
  flagRiconosciutoDallaMadre?: string;
  flagInfraQuattordicenne?: string;
  flagPresenzaDiscendenti?: string;
  discendenti?: number;
  attoNascita?: number;
  assensoAtto?: number;
  flagPreMorto?: string;
  tipoSezione?: string;
  codiceSezione?: string;
}

export interface TrascrizioneNascita {
  key?: {
    idEvento?: number;
  };
  dataComunicazione?: string;
  trascrizione?: string;
  idAutoritaMittente?: number;
  idAttoEstero?: number;
  idAtto?: number;
  tipoRichiedenteNascita?: string;
  luogoNascita?: string;
  specificaLuogoNascita?: string;
  riconoscimentoNascita?: string;
  flagFiglioDiIgnoti?: string;
  genitoreMutazioneCognome?: string;
  provvedCambioCognome?: string;
  idPrefettura?: number;
  dataProvvedCambioCognome?: string;
  cambioCognome?: string;
  vecchioCognomeGenitore?: string;
  sceltaCognome?: string;
  nuovoCognome?: string;
  nuovoNome?: string;
  cognomeAggiunto?: string;
  nomeAggiunto?: string;
  volontaEspressa?: string;
  idIstituto?: number;
  idAttoCambioCognome?: number;
  flagRiconPaternoConSentenza?: string;
  dichiarazione?: number;
  richiedenteNascita?: string;
  descrizioneRichiedenteNascita?: string;
  numeroIntestatari?: number;
  numeroFigli?: number;
  codiceSezione?: string;
  configurazione?: string;
  tipoSezione?: string;
}

export interface TrascrizioneMorte {
  key?: {
    idEvento?: number;
  };
  dichiarazione?: string;
  dataComunicazione?: string;
  trascrizione?: string;
  idAutoritaMittente?: string;
  idAtto?: string;
  idAttoEstero?: string;
  dataUltimoAvvistamento?: string;
  tipoScomparsa?: string;
  idUltimoLuogo?: string;
  idAnnotazMortePresunta?: string;
  codiceSezione?: string;
}

export interface TrascrizioneCittadinanza {
  key?: {
    idEvento?: number;
  };
  dichiarazione?: string;
  dataComunicazione?: string;
  trascrizione?: string;
  idAutoritaMittente?: number;
  idAtto?: number;
  idAttoEstero?: number;
  dataAccertamento?: string;
  esitoAccertamento?: string;
  dataProvvedimentoSindaco?: string;
  dataMatrimonio?: string;
  dataEfficaciaProvvedEstero?: string;
  protocollo?: string;
  dataPassatoInGiudicato?: string;
  pecMinistero?: string;
  ulterioreCittadinanza?: number;
  nomeUlterioreCittadinanza?: string;
  idDecretoIntimazione?: number;
  genitoreConCittadinanza?: string;
  flagCambioGeneralita?: string;
  flagRichiestaPerPosta?: string;
  codiceSezione?: string;
}

export interface Ascendente {
  gradoParentela?: string;
}

export interface AttoCollegato {
  key?: {
    idAttoCollegato?: number;
  };
  idAnsc?: string;
  tipoAttoPresentato?: string;
  tipoContenuto?: string;
  ente?: string;
  idComuneRegistrazione?: number;
  nomeComuneRegistrazione?: string;
  idProvRegistrazione?: number;
  siglaProvRegistrazione?: string;
  flagRedattoNellaCC?: string;
  idLuogoRedazione?: number;
  numeroAtto?: number;
  dataFormazioneAtto?: string;
  annoAtto?: number;
  meseAtto?: number;
  giornoAtto?: number;
  oraAtto?: number;
  minutoAtto?: number;
  dataAtto?: string;
  tipologiaAtto?: string;
  parteAtto?: string;
  serieAtto?: string;
  volumeAtto?: string;
  estremiAtto?: string;
  nomeOperatore?: string;
  cognomeOperatore?: string;
  tipoSezione?: string;
  sezione?: string;
}

export interface Composizione {
  codiceSezione?: string;
  composizioneCompleta?: string;
}

export interface Consenso {
  key?: {
    idConsenso?: number;
  };
  tipoConsenso?: string;
  mancatoConsenso?: string;
  datiProdotti?: string;
  idAttoCollegato?: number;
  idAltroUfficiale?: number;
  idSentenzaTribunale?: number;
  codiceSezione?: string;
  tipoSezione?: string;
}

export interface DatiAssenso {
  key?: {
    idEvento?: number;
  };
  tipoAssenso?: string;
}

export interface Luogo {
  key?: {
    idLuogo?: number | null;
  };
  idComune?: number;
  nomeComune?: string;
  idProvincia?: number;
  siglaProvincia?: string;
  idStato?: number;
  nomeStato?: string;
  luogo?: string;
  indirizzo?: string;
  civico?: string;
  lettera?: string;
  nomeComuneEstero?: string;
  codiceSezione?: string;
  tipoSezione?: string;
}

export interface DatiAnnotazioneList {
  key?: {
    idDatiAnnotazione?: number;
  };
  idEvento?: number;
  annotazione?: string;
  tipoAnnotazione?: string;
  flagAnnotazioneNonCert?: string;
  timestampInserimento?: string;
}

export interface UnioneCivileAtti {
  key?: {
    idEvento?: number;
  };
  dataEvento?: string;
  oraEvento?: number;
  minutoEvento?: number;
  numeroTestimoni?: number;
  flagRigettoOpposizione?: string;
  flagEstintaOpposizione?: string;
  tipoImpedimentoGenerico?: string;
  tipoSoggettoConImpedimento?: string;
  tipoOfficiante?: string;
  codiceSezione?: string;
  configurazione?: string;
  dataDelega?: string;
  testoDelega?: string;
  idNazioneDelegante?: number;
  nomeNazioneDelegante?: string;
  idConsolatoDelegante?: number;
  nomeConsolatoDelegante?: string;
  idComuneDelegante?: number;
  nomeComuneDelegante?: string;
  idProvinciaDelegante?: number;
  siglaProvinciaDelegante?: string;
  tipoComprensioneConiuge1?: string;
  descrizioneImpedimentoScritturaConiuge1?: string;
  tipoComprensioneConiuge2?: string;
  descrizioneImpedimentoScritturaConiuge2?: string;
  tipoRuoloSegretario?: string;
  flagConiuge1InPericoloVita?: string;
  descrizioneAccertamentoVolontaConiuge1?: string;
  flagConiuge2InPericoloVita?: string;
  descrizioneAccertamentoVolontaConiuge2?: string;
}

export interface CertificatoUnioneCivileList {
  key?: {
    idCertificatoUnioneCivile: string;
  };
  idComune?: number;
  nomeComune?: string;
  idProvincia?: number;
  siglaProvincia?: string;
  dataRichiestaCostituzione?: string;
  codiceSezione?: string;
  tipoSezione?: string;
}

export interface RegimePatrimoniale {
  key?: {
    idRegimePatrimoniale?: number | null;
  };
  tipoRegimePatrimoniale?: string;
  flagConAttoNotarile?: string;
  descrizioneCognomeNotaio?: string;
  descrizioneNomeNotaio?: string;
  nomeDistrettoNotarile?: string;
  dataAttoNotarile?: string;
  numeroLegge?: string;
  numeroRepertorio?: string;
  numeroRaccolta?: string;
  codiceSezione?: string;
  tipoSezione?: string;
}

export interface Impedimento {
  key?: {
    idImpedimento: number | null;
  };
  idCertificato?: number;
  testoMotivazione?: string;
  sezione?: string;
  codiceSezione?: string;
  tipoPersistenza?: string;
}

export interface MatrimonioAtti {
  key?: {
    idEvento?: number;
  };
  dataEvento?: string;
  oraEvento?: number;
  minutoEvento?: number;
  numeroTestimoni?: number;
  flagRigettoOpposizione?: string;
  flagEstintaOpposizione?: string;
  tipoImpedimentoParentela?: string;
  tipoDifettoEta?: string;
  flagDivietoTemporaneo?: string;
  idPadreSposo?: number;
  idPadreSposa?: number;
  idMadreSposo?: number;
  idMadreSposa?: number;
  idAssistenteLegaleSposo?: number;
  idAssistenteLegaleSposa?: number;
  flagPiuPubblicazioni?: string;
  flagOmissionePubblicazione?: string;
  tipoAssistenteSposo?: string;
  tipoAssistenteSposa?: string;
  dataDelega?: string;
  testoDelega?: string;
  idNazioneDelegante?: number;
  nomeNazioneDelegante?: string;
  idConsolatoDelegante?: number;
  nomeConsolatoDelegante?: string;
  idComuneDelegante?: number;
  nomeComuneDelegante?: string;
  idProvinciaDelegante?: number;
  siglaProvinciaDelegante?: string;
  tipoSoggettoConImpedimento?: string;
  flagRiduzTerminiPubblicaz?: string;
  tipoOfficiante?: string;
  tyOfficianteTrasmisAtto?: string;
  tipoRuoloSegretario?: string;
  descrizioneRitoReligioso?: string;
  tipoDichiarMatrReligioso?: string;
  flagRitoRiconosciuto?: string;
  idConsensoRiconoscimento?: string;
  tipoComprensioneSposo?: string;
  descrizioneImpedimScritturaSposo?: string;
  tipoComprensioneSposa?: string;
  descrizioneImpedimScritturaSposa?: string;
  flagSposoInPericoloVita?: string;
  descrizioneAccertamVolontaSposo?: string;
  flagSposaInPericoloVita?: string;
  descrizioneAccertamVolontaSposa?: string;
  codiceSezione?: string;
}

export interface ScioglimentoUnioneCivileAtti {
  key?: {
    idEvento?: number;
  };
  idAttoUnioneCivile?: number;
  tipoComprensioneConiuge1?: string;
  descrizioneImpedimScrittConiuge1?: string;
  tipoComprensioneConiuge2?: string;
  descrizioneImpedimScrittConiuge2?: string;
  dataComunicazione?: string;
  dataRicezione?: string;
  flagConRaccomandataAr?: string;
  descrizioneAltroMezzoComunicaz?: string;
  flagInGiudizioPendente?: string;
  tipoIndirizzoComunicazione?: string;
  descrizioneAutoritaGiudiziaria?: string;
  flagPresenzaAvvConiuge1?: string;
  idAvvocatoConiuge1?: number;
  nomeForoAvvConiuge1?: string;
  flagPresenzaConiuge1?: string;
  flagPresenzaAvvConiuge2?: string;
  idAvvocatoConiuge2?: number;
  nomeForoAvvConiuge2?: string;
  flagPresenzaConiuge2?: string;
  dataConfermaAccordo?: string;
  idAccordoScioglimento?: number;
  flagAssegnoMantenimento?: string;
  descrizioneDatiAssegnoMantenim?: string;
  dataUnioneCivile?: string;
  idLuogoUnioneCivile?: number;
  descrizioneOfficianteUnioneCivile?: string;
  codiceSezione?: string;
}

export interface Pubblicazione {
  key?: {
    idPubblicazione?: number;
  };
  idComune?: number;
  nomeComune?: string;
  idProvincia?: number;
  siglaProvincia?: string;
  idNazione?: number;
  nomeNazione?: string;
  anagraficaConsolato?: number;
  nomeAnagraficaConsolato?: string;
  dataInizio?: string;
  dataFine?: string;
  codiceSezione?: string;
  tipoSezione?: string;
}

export interface TrascrizioneUnioneCivile {
  key?: {
    idEvento?: number;
  };
  dichiarazione?: string;
  tipoTrascrizione?: string;
  dataComunicazione?: string;
  trascrizione?: string;
  idAutoritaMittente?: number;
  idAtto?: number;
  idAttoEstero?: number;
  tipoOfficiante?: string;
  titoloOfficiante?: string;
  idOfficiante?: number;
  codiceSezione?: string;
}

export interface Separazione {
  key?: {
    idEvento?: number;
  };
  tipoAccordo?: string;
  flagPresenzaConiuge1?: string;
  flagPresenzaAvvConiuge1?: string;
  idAvvocatoConiuge1?: number;
  nomeForoAvvUnico?: string;
  nomeForoAvvConiuge1?: string;
  flagPresenzaConiuge2?: string;
  flagPresenzaAvvConiuge2?: string;
  idAvvocatoConiuge2?: number;
  nomeForoAvvConiuge2?: string;
  idAttoMatrimonio?: number;
  flagInGiudizioPendente?: string;
  descrizioneAutoritaGiudiziaria?: string;
  dataConfermaAccordo?: string;
  idAccordoSeparazione?: number;
  idProvvedimentoSeparazione?: number;
  testoModificaAccordo?: string;
  tipoProvvedimentoSeparazione?: string;
  dataEventoMatrimonio?: string;
  idLuogoEventoMatrimonio?: number;
  descrizioneOfficianteEventoMatrimoni?: string;
  tipoSeparazioneDivorzio?: string;
  flagAssegnoMantenimento?: string;
  descrizioneDatiAssegnoMantenimento?: string;
  idConfermaAccordoSeparazione?: number;
  flagAvvocatoUnico?: string;
  codiceSezione?: string;
  tipoSezione?: string;
}

export interface TrascrizioneMatrimonioAtti {
  key?: {
    idEvento?: number;
  };
  dichiarazione?: string;
  dataComunicazione?: string;
  trascrizione?: string;
  idAutoritaMittente?: number;
  idAtto?: number;
  idAttoEstero?: number;
  descrizioneTitoloOfficiante?: string;
  idOfficiante?: number;
  codiceSezione?: string;
  configurazione?: string;
}

export interface NegoziazioneAssistita {
  key?: {
    idEvento?: number;
  };
  accordo?: string;
  provvedimento?: string;
  ricezioneAtto?: string;
  trascrizioneAccordo?: string;
  dataStipulaAccordo?: string;
  dataDepositoProvvedimento?: string;
  dataComunicazProvvedimento?: string;
  ricezioneAttoConiuge1?: string;
  ricezioneAttoConiuge2?: string;
  foroAvvConiuge1?: string;
  foroAvvConiuge2?: string;
  dataRicezioneAttoConiuge1?: string;
  dataRicezioneAttoConiuge2?: string;
  protocolloAttoConiuge1?: string;
  protocolloAttoConiuge2?: string;
  codiceSezione?: string;
}

export interface DatiIntegrativiTrascrizione {
  key?: {
    idEvento?: number;
  };
  numeroOraDocumento?: string;
  numeroMinutoDocumento?: string;
  cognomeRedattore?: string;
  nomeRedattore?: string;
  sesso?: string;
  codiceTemplate?: string;
  codiceSezione?: string;
  motivoDelega?: string;
  descrizioneUfficialeDelegante?: string;
}

export interface TrascrizioneSeparazioneAtti {
  key?: {
    idEvento?: number;
  };
  tipoDichiarazione?: string;
  flagNotificaDaPrivCittad?: string;
  dataComunicazione?: string;
  trascrizione?: string;
  idModificaMatrimonio?: string;
  dataPubblicazioneSentenza?: string;
  dataDecorrenzaSentenza?: string;
  codiceSezione?: string;
}

export interface Riconciliazione {
  key?: {
    idEvento?: number;
  };
  idAttoMatrimonio?: number;
  idProvvedimentoSeparazione?: number;
  dataRiconciliazione?: string;
  idLuogoMatrimonio?: number;
  idAttoAccordoSeparazione?: number;
  idAttoConfermaAccordoSeparazione?: number;
  idAttoNegoziazioneAssistita?: number;
  descUfficianteMatrimonio?: string;
  dataMatrimonio?: string;
  codiceSezione?: string;
}

export interface Richiedente {
  key?: {
    idEvento?: number;
  };
  tipoRichiedente?: string;
}

export interface AnnotazioneModificativa {
  key?: {
    idEvento?: number;
  };
  idAttoIntestatario?: number;
  idAttoGenitore?: number;
  modifica?: string;
  genitore?: string;
  descrizioneNuovoCognomeGenitore?: string;
  descrizioneNuovoNomeGenitore?: string;
  descrizioneVecchioCognomeGenitore?: string;
  descrizioneVecchioNomeGenitore?: string;
  descrizioneNuovoCognomeIntestatario?: string | null;
  descrizioneNuovoNomeIntestatario?: string | null;
  descrizioneVecchioCognomeIntestatario?: string | null;
  descrizioneVecchioNomeIntestatario?: string | null;
  idSoggettoCollegato?: number;
  codiceSezione?: string;
}

export interface RiferimentiPubblicazione {
  key?: {
    idEvento?: number;
  };
  numeroAnno?: number;
  numeroAtto?: number;
  codiceParte?: string;
  codiceSerie?: string;
  codiceRegistro?: string;
  codiceSezione?: string;
}

export interface DataWizardAct {
  questionarioEvento?: Array<QuestionarioEvento>;
  statoCivile?: StatoCivile;
  evento?: Evento;
  allegatoList?: Array<AttachmentsData>;
  soggettoList?: Array<SoggettoList>; // tutti soggetti
  figlioList?: Array<FiglioList>;
  firmatariList?: Array<FirmatariList>;
  datiNascita?: DatiNascita;
  datiDichiarante?: DatiDichiarante; // soggetto con flagDichiarante === '1'
  enteDichiaranteList?: Array<EnteDichiaranteList>;
  datiMorte?: DatiMorte;
  datiEventoMorte?: DatiEventoMorte;
  datiEventoCittadinanza?: DatiEventoCittadinanza;
  certificatoSanitario?: CertificatoSanitario;
  datiEventoRiconoscimento?: DatiEventoRiconoscimento;
  trascrizioneNascita?: TrascrizioneNascita;
  trascrizioneMorte?: TrascrizioneMorte;
  trascrizioneCittadinanza?: TrascrizioneCittadinanza;
  ascendente?: Ascendente;
  riconoscimentoList?: Array<RiconoscimentoList>;
  attoCollegatoList?: Array<AttoCollegato>;
  consenso?: Consenso;
  composizione?: Composizione;
  datiAssenso?: DatiAssenso;
  luogo?: Luogo;
  datiAnnotazioneList?: Array<DatiAnnotazioneList>;
  unioneCivileAtti?: UnioneCivileAtti;
  certificatoUnioneCivileList?: Array<CertificatoUnioneCivileList>;
  regimePatrimoniale?: RegimePatrimoniale;
  impedimentoList?: Array<Impedimento>;
  matrimonioAtti?: MatrimonioAtti;
  scioglimentoUnioneCivileAtti?: ScioglimentoUnioneCivileAtti;
  pubblicazioneList?: Array<Pubblicazione>;
  trascrizioneUnioneCivile?: TrascrizioneUnioneCivile;
  separazione?: Separazione;
  trascrizioneMatrimonioAtti?: TrascrizioneMatrimonioAtti;
  negoziazioneAssistita?: NegoziazioneAssistita;
  datiIntegrativiTrascrizione?: DatiIntegrativiTrascrizione;
  trascrizioneSeparazioneAtti?: TrascrizioneSeparazioneAtti;
  riconciliazione?: Riconciliazione;
  richiedente?: Richiedente;
  annotazioneModificativa?: AnnotazioneModificativa;
  riferimentiPubblicazione?: RiferimentiPubblicazione;
  operatoreUsc?: ActOperator;
  idEventoGemelloSuccessivo?: number;
}
